// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"TabGroup_tabGroup_AOQ20"};